import React from 'react';
import { withTranslation } from '../../lib/translate';
import { withRouter } from 'react-router';
import { NormalText, Spacer, Title } from '../../components/common';
import { connect } from 'react-redux';
import wrong from '../../assets/images/Deli_Wrong.svg';
import succees from '../../assets/images/Deli_Check.svg';
import { IonIcon } from '@ionic/react';
import { GET_ORDER_HISTORY } from '../../store/constants';
import { forwardTo, isNative } from '../../lib/utils';
import { Browser } from '@capacitor/browser';
import Basket from '../../lib/basket';

const isWeb = () => Capacitor.getPlatform() === 'web';

class NativeOrderStatus extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		const url = new URL(window.location.href);
		if(window?.mobileApp){
			window.mobileApp.postMessage({ detail: { message: "redirect" } });
		}else if(isNative()){
			forwardTo('/order-completed?status=success');
		}else{
			console.log("MobileApp not found")
		}

		/* const searchParams = new URLSearchParams(this.props.location.search);
		const orderId = searchParams.get('order');
		const status = searchParams.get('status');
		this.setState({ status });
		if(!isWeb()){
			if(status === 'canceled'){
				forwardTo('/order-summary');
			}else if(status === 'success'){
				Basket.reset();
				this.props.dispatch({ type: GET_ORDER_HISTORY, orderId: orderId });
				forwardTo('/order-completed');
			}
			try {
				Browser.close();
			} catch (error) {
				console.log('Error closing capacitor Browser:',error )	
			}
		} */

	}
	render() {
		const { __ } = this.props;
		return (
			<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',  marginTop: '30px' }}>
				<IonIcon style={{ width: '70px', height: '70px' }} slot="icon-only" icon={succees} />
				<Title style={{ margin: 0 }}>{__('You can safely return to the app.')}</Title>
				<NormalText>{__(' Payment details will appear there.')}</NormalText>
				<NormalText>{__('Please close this page.')}</NormalText>
			{(() => {
				const url = new URL(window.location.href);
				return (
					<a
						href={`${url.origin}/order-completed?status=success`}
						style={{
							display: 'inline-block',
							marginTop: 20,
							padding: '10px 20px',
							background: '#120621',
							color: '#fff',
							borderRadius: 4,
							textDecoration: 'none',
							fontWeight: 600
						}}
					>
						{__('Close')}
					</a>
				);
			})()}
			</div>
		);
	}
}
const mapStateToProps = (store) => {
	return {};
};
export default connect(mapStateToProps)(withRouter(withTranslation(NativeOrderStatus)));
